const { fillWithDomElementsAll, trackLink } = require('util/functions');

const SELECTOR_TILE = '.social-media-highlights--tile';
const CLASS_LINK = 'social-media-highlights--link';
const CLASS_SHARE = 'social-media-highlights--share';
const CLASS_FOLLOW = 'social-media-highlights--follow';

const selectorsAll = {
	links: CLASS_LINK,
	shares: CLASS_SHARE,
	follows: CLASS_FOLLOW,
};

module.exports = {
	init() {
		fillWithDomElementsAll(this, selectorsAll);
		[
			[this.links, 'tweet'],
			[this.shares, 'tweet share'],
			[this.follows, 'tweet follow'],
		].forEach(([elements, label]) => {
			elements.forEach(element => {
				element.addEventListener('click', e => {
					this.trackGTM(e, label);
				});
			});
		});
	},
	trackGTM({ target }, eventLabelName) {
		const url = target
			.closest(SELECTOR_TILE)
			.querySelector('.' + CLASS_LINK).href;
		trackLink(eventLabelName, url);
	},
};
